import {api, investments_api} from '@/store/resources'

export default {
    namespaced: true,
    state: {
        portfolios_list: {
            data: [],
            dirty: true
        },
        current_portfolio: {
            data: null,
            dirty: true
        }
    },
    getters: {
        portfolioCurrency: (state, getters, rootState, rootGetters) => {
            return rootGetters['cabinet/currencies/getCurrencyByCode'](state.current_portfolio.data.currency)
        }
    },
    actions: {
        getPortfolios({commit, rootState}) {
            return new Promise((resolve, reject) => {
                commit('setPortfolioListDirty');
                const space_id = rootState.space.current_space.data.id;
                investments_api.portfolios.get({space_id}).then(res => {
                    if (res.body.success) {
                        commit('setPortfolioList', res.body.data.rows)
                        resolve()
                    } else {
                        console.log(res)
                        reject()
                    }
                });
            })
        },
        getPortfolio({commit, rootState}, id) {
            const space_id = rootState.space.current_space.data.id;
            return investments_api.portfolios.get({id, space_id})
        },
        createPortfolio({}, data) {
            return investments_api.portfolios.save(data);
        },
        updatePortfolio({}, data) {
            return investments_api.portfolios.update({id: data.id}, data);
        },
        archivePortfolio({}, id) {
            return investments_api.portfolios.delete({id});
        },
        purgePortfolio({}, portfolio_id) {
            return investments_api.purge_portfolio.save({portfolio_id});
        },
        updatePortfolioBalance({}, data) {
            return api.transfers.save(data)
        },
        updateCurrentPortfolioInfo({commit, state}) {
            const currentPortfolioId = state.current_portfolio.data.id,
                portfolio = state.portfolios_list.data.find(i => i.id === currentPortfolioId)
            commit('setActivePortfolio', portfolio)
        },

        uploadPortfolio({}, data) {
            return investments_api.upload_portfolio_report.save(data);
        },
        importPortfolio({state}, appliedDuplicateIds) {
            return investments_api.import_portfolio
                .save({portfolio_id: state.current_portfolio.data.id, appliedDuplicateIds});
        },
    },
    mutations: {
        setActivePortfolio(state, data) {
            state.current_portfolio.data = data;
            state.current_portfolio.dirty = false;
        },
        setPortfolioListDirty(state) {
            state.portfolios_list.dirty = true;
            state.current_portfolio.dirty = true;
        },
        setPortfolioList(state, data) {
            state.portfolios_list.data = data;
            state.portfolios_list.dirty = false;
        },
        clearPortfolios(state) {
            state.portfolios_list.data = [];
            state.current_portfolio.data = null;
        },
        setPortfolioRecalculating(state, data) {
            state.current_portfolio.data.recalculation = data;
        }
    }
}